import Vue from 'vue'
import flatpickr from "flatpickr";
import { Russian } from "flatpickr/dist/l10n/ru.js"
//
flatpickr.setDefaults(
{
    locale: Russian,
    enableTime: true,
    dateFormat: 'd-m-Y H:i',
    time_24hr: true,
    minDate: 'today'
})


Vue.use(flatpickr)


